interface BudgetMechanism {
  name: string;
  approvedValue: number;
  capturedValue: number;
  balance: number;
}

interface BudgetSummaryTableProps {
  mechanisms: BudgetMechanism[];
}

export function BudgetSummaryTable({ mechanisms }: BudgetSummaryTableProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  // Calculate totals
  const totals = mechanisms.reduce(
    (acc, mechanism) => ({
      approvedValue: acc.approvedValue + mechanism.approvedValue,
      capturedValue: acc.capturedValue + mechanism.capturedValue,
      balance: acc.balance + mechanism.balance,
    }),
    { approvedValue: 0, capturedValue: 0, balance: 0 }
  );

  return (
    <div className="flex flex-col gap-[6px] w-full">
      {/* Header Row */}
      <div className="bg-[#7846FF] flex gap-[6px] h-[53px] items-center rounded-[10px] w-full">
        <div className="flex gap-[10px] h-[68px] items-center justify-center pl-[30px] pr-[10px] w-[414px]">
          <p className="font-['Plus_Jakarta_Sans'] font-bold leading-[1.4] text-[#f6f6f6] text-[16px] flex-1">
            Mecanismo
          </p>
        </div>
        <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
          <p className="font-['Plus_Jakarta_Sans'] font-bold leading-[1.4] text-[#f6f6f6] text-[16px] flex-1">
            Valores Aprovados
          </p>
        </div>
        <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
          <p className="font-['Plus_Jakarta_Sans'] font-bold leading-[1.4] text-[#f6f6f6] text-[16px] flex-1">
            Valores Captados
          </p>
        </div>
        <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
          <p className="font-['Plus_Jakarta_Sans'] font-bold leading-[1.4] text-[#f6f6f6] text-[16px] flex-1">
            Saldo
          </p>
        </div>
      </div>

      {/* Data Rows */}
      {mechanisms.map((mechanism, index) => (
        <div
          key={index}
          className={`flex gap-[6px] h-[53px] items-center w-full ${
            index % 2 === 1 ? 'bg-[#0C1427] rounded-[10px]' : ''
          }`}
        >
          <div className="flex gap-[10px] h-[68px] items-center justify-center pl-[30px] pr-[10px] w-[414px]">
            <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
              {mechanism.name}
            </p>
          </div>
          <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
            <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
              {formatCurrency(mechanism.approvedValue)}
            </p>
          </div>
          <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
            <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
              {formatCurrency(mechanism.capturedValue)}
            </p>
          </div>
          <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
            <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
              {formatCurrency(mechanism.balance)}
            </p>
          </div>
        </div>
      ))}

      {/* Total Row */}
      <div className="bg-[#0C1427] flex gap-[6px] h-[53px] items-center rounded-[10px] w-full">
        <div className="flex gap-[10px] h-[68px] items-center justify-center pl-[30px] pr-[10px] w-[414px]">
          <p className="font-['Plus_Jakarta_Sans'] font-bold leading-[1.4] text-[#f6f6f6] text-[16px] flex-1">
            Total
          </p>
        </div>
        <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
            {formatCurrency(totals.approvedValue)}
          </p>
        </div>
        <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
            {formatCurrency(totals.capturedValue)}
          </p>
        </div>
        <div className="flex gap-[10px] h-[68px] items-center justify-center flex-1">
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[16px] flex-1">
            {formatCurrency(totals.balance)}
          </p>
        </div>
      </div>
    </div>
  );
}
